/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceArtefactSerialiser } from './EvidenceArtefactSerialiser';
import {
  EvidenceArtefactSerialiserFromJSON,
  EvidenceArtefactSerialiserFromJSONTyped,
  EvidenceArtefactSerialiserToJSON,
} from './EvidenceArtefactSerialiser';

/**
 *
 * @export
 * @interface PaginatedEvidenceArtefactSerialiserList
 */
export interface PaginatedEvidenceArtefactSerialiserList {
  /**
   *
   * @type {number}
   * @memberof PaginatedEvidenceArtefactSerialiserList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedEvidenceArtefactSerialiserList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedEvidenceArtefactSerialiserList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<EvidenceArtefactSerialiser>}
   * @memberof PaginatedEvidenceArtefactSerialiserList
   */
  results: Array<EvidenceArtefactSerialiser>;
}

/**
 * Check if a given object implements the PaginatedEvidenceArtefactSerialiserList interface.
 */
export function instanceOfPaginatedEvidenceArtefactSerialiserList(
  value: object,
): value is PaginatedEvidenceArtefactSerialiserList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedEvidenceArtefactSerialiserListFromJSON(json: any): PaginatedEvidenceArtefactSerialiserList {
  return PaginatedEvidenceArtefactSerialiserListFromJSONTyped(json, false);
}

export function PaginatedEvidenceArtefactSerialiserListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedEvidenceArtefactSerialiserList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(EvidenceArtefactSerialiserFromJSON),
  };
}

export function PaginatedEvidenceArtefactSerialiserListToJSON(
  value?: PaginatedEvidenceArtefactSerialiserList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(EvidenceArtefactSerialiserToJSON),
  };
}
